import cornerstone from 'cornerstone-core';
import { importInternal } from 'cornerstone-tools';
import _ from 'lodash';

import { booleanOperation } from './booleanOperation';

const draw = importInternal('drawing/draw');

export function booleanPainter(toolState, structureSetSeriesInstanceUid) {
  let state = _.cloneDeep(toolState);
  let subjectROINumber = '';
  let objectROINumber = '';
  let booleanROINumber = '';
  let method = '';
  let booleanData;

  return {
    getState: function() {
      return state;
    },
    commit: function(evt) {
      if (!booleanData) {
        return;
      }
      booleanROINumber = evt.booleanROINumber;
      state.data = [
        ...state.data,
        ...booleanData.map(data => {
          return { ...data, ROINumber: booleanROINumber };
        }),
      ];

      // clear preview line
      subjectROINumber = '';
      objectROINumber = '';
      method = '';
    },
    update: function(evt) {
      subjectROINumber = evt.subjectROINumber;
      objectROINumber = evt.objectROINumber;
      method = evt.method;
      this.subjectROINumber = subjectROINumber;
      this.objectROINumber = objectROINumber;
      this.method = method;
      if (subjectROINumber !== '' && objectROINumber !== '' && method !== '') {
        booleanData = getBooleanData(
          state,
          structureSetSeriesInstanceUid,
          subjectROINumber,
          objectROINumber,
          booleanROINumber,
          method
        );
      }
    },
    cursor: function(evt, context) {
      if (subjectROINumber === '' || objectROINumber === '' || method === '') {
        return;
      }
      if (!booleanData || booleanData.length === 0) {
        return;
      }
      const element = evt.detail.element;
      const pointsData = booleanData.map(data =>
        data.handles.points.map(point =>
          cornerstone.pixelToCanvas(element, point)
        )
      );
      pointsData.forEach(points => {
        draw(context, context => {
          context.strokeStyle = 'rgba(217, 83, 79, 1)';
          context.fillStyle = 'rgba(217, 83, 79, 0.2)';
          context.lineWidth = 3;
          context.beginPath();
          context.moveTo(points[0].x, points[0].y);
          for (let i = 1; i < points.length; i++) {
            context.lineTo(points[i].x, points[i].y);
          }
          context.closePath();
          context.stroke();
          context.fill();
        });
      });
      return true;
    },
  };
}

function getBooleanData(
  state,
  structureSetSeriesInstanceUid,
  subjectROINumber,
  objectROINumber,
  booleanROINumber,
  method
) {
  const booleanData = [];
  const polygons1 = state.data
    .filter(d => d.ROINumber == subjectROINumber)
    .map(d => [d.handles.points.map(v => [v.x, v.y])]);
  const polygons2 = state.data
    .filter(d => d.ROINumber == objectROINumber)
    .map(d => [d.handles.points.map(v => [v.x, v.y])]);
  const booleanPolygons = booleanOperation(method, polygons1, polygons2);

  booleanPolygons.forEach(polygon => {
    polygon.forEach(segment => {
      booleanData.push({
        ROINumber: booleanROINumber,
        handles: {
          points: segment.map(v => ({ x: v[0], y: v[1] })),
        },
        structureSetSeriesInstanceUid: structureSetSeriesInstanceUid,
      });
    });
  });

  return booleanData;
}
